import { all, fork } from "redux-saga/effects";

//public
import CheckAuthTypeSaga from "./Admin/auth/checkAuthType/saga";
import AuthSaga from "./Admin/auth/login/saga";
import ForgetSaga from "./Admin/auth/forgetpwd/saga";
import ProfileSaga from "./Admin/auth/profile/saga";
import LayoutSaga from "./layout/saga";

// dashboard
import dashboardSaga from "./dashboard/saga";

// Aspirations question
import aspirationQuestionSaga from "./Admin/aspirations/aspirationsQuestion/saga";
// Schor Horizontal
import schorHorizontalSaga from "./Admin/aspirations/schorHorizontal/saga";
// Schor Vertical
import schorVerticalSaga from "./Admin/aspirations/schorVertical/saga";

// Questionnaire
import QuestionnaireSaga from "./Admin/questionnaire/saga";

// Invitations
// Participants invites
import ParticipantsInvitesSaga from "./Admin/Invitations/Participants/Invites/saga";
// Raters invites
import RatersInvitesSaga from "./Admin/Invitations/Raters/Invites/saga";

// Reminders
// Participants invites
import ParticipantsRemindersSaga from "./Admin/Reminders/Participants/saga";

// Batches
import BatchesSaga from "./Admin/batches/saga";

// Mail
import MailBatchSaga from "./Admin/email/saga";

// Norms
import Norms from "./Admin/email copy/saga";

//Configurations Language
import configLanguageSaga from "./Admin/configurations/language/saga";

//Configurations Chart Color
import ConfigChartColorSaga from "./Admin/configurations/ChartColor/saga";

//Survey Text Welcome
import configSurveyWelcomeSaga from "./Admin/configurations/surveytext/welcome/saga"

//Survey Text Middle
import configSurveyMiddleSaga from "./Admin/configurations/surveytext/middle/saga"

//Survey Text Thank You
import configThankYouSaga from "./Admin/configurations/surveytext/thankyou/saga"

//Config Raters Type
import configRatersTypeSaga from "./Admin/configurations/raterstype/saga"

// ******************************** => Participant // Rater Panel <= **************************************
import ParticipantAuthSaga from "./Participant/auth/login/saga";
import ParticipantForgetSaga from "./Participant/auth/forgetpwd/saga";
import ParticipantProfileSaga from "./Participant/auth/profile/saga";

// raters invite 
import RatersInviteSaga from "./Participant/RatersInvite/saga";

// Survey
import SurveySaga from "./Participant/CompleteSelfServey/saga";

export default function* rootSaga() {
  yield all([
    fork(CheckAuthTypeSaga),
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    fork(LayoutSaga),
    fork(dashboardSaga),
    fork(aspirationQuestionSaga),
    fork(schorHorizontalSaga),
    fork(schorVerticalSaga),
    fork(ParticipantsInvitesSaga),
    fork(ParticipantsRemindersSaga),
    fork(RatersInvitesSaga),
    fork(BatchesSaga),
    fork(MailBatchSaga),
    fork(configLanguageSaga),
    fork(configSurveyWelcomeSaga),
    fork(ConfigChartColorSaga),
    fork(configSurveyMiddleSaga),
    fork(QuestionnaireSaga),
    fork(configThankYouSaga),
    fork(configRatersTypeSaga),
    fork(Norms),
    // ******************************** => Participant // Rater Panel <= **************************************

    fork(ParticipantAuthSaga),
    fork(ParticipantForgetSaga),
    fork(ParticipantProfileSaga),
    fork(RatersInviteSaga),
    fork(SurveySaga)
  ]);
}
